import { PortfolioProject } from '../../types';
import { orderSkills } from '../../utils/orderTags/orderSkills';

export const mapProjects = (projects: PortfolioProject[], roleId?: string) =>
    projects.map((project) => {
        const services = project.portfolioProjectRoleCatalog.services.map(({ id, displayName }) => ({
            id,
            name: displayName.value,
        }));

        const skills = project.portfolioProjectRoleCatalog.metadata.map(({ id, name, iconUrl }) => ({
            id,
            name: name.value,
            iconUrl: iconUrl || undefined,
        }));

        const tags = orderSkills([...services, ...skills], roleId);

        return {
            ...project,
            tags,
        };
    });
